const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');
import { formatText } from 'core/i18n';

const setInitialState = () => {
    return Immutable.Map().merge({
        precontractualInfo: [],
        pdfDownloadLink: null,
        accountType: 0,
        isLoadedInDocumentationInfo: false,
        fromInitialStep: false,
    });
};

const initialState = setInitialState();

const initialStepReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_CONTRACTUAL_INFO:
            let accountType = state.get('accountType');
            let precontractualInfo = state.get('precontractualInfo');
            action.data.map(value => {
                let title;
                let text;
                let priority;
                let descripcion = value.descripcion;
                descripcion = descripcion.toLowerCase();

                if (descripcion.includes('corriente')) {
                    title = formatText('documentation-acountTitle1');
                    text = 'documentation-acountText1';
                    priority = 1;
                } else if (descripcion.includes('debito')) {
                    title = formatText('documentation-acountTitle2');
                    text = 'documentation-acountText2';
                    priority = 3;
                } else if (descripcion.includes('home')) {
                    title = formatText('documentation-acountTitle5');
                    text = 'documentation-acountText5';
                    priority = 2;
                    accountType = 3;
                } else if (descripcion.includes('nomina')) {
                    if (descripcion.includes('bienvenida')) {
                        title = formatText('documentation-acountTitle4');
                        text = 'documentation-acountText4';
                        priority = 0;
                        accountType = 5;
                    } else {
                        title = formatText('documentation-acountTitle3');
                        text = 'documentation-acountText3';
                        accountType = 1;
                        priority = 2;
                    }
                } else if (descripcion.includes('bienvenida')) {
                    title = value.descripcion;
                    text = 'documentation-acountText0';
                    accountType = 2;
                    priority = 2;
                } else if (descripcion.includes('open debit')) {
                    title = value.descripcion;
                    text = 'documentation-acountText0';
                    accountType = 2;
                    priority = 2;
                } else {
                    title = value.descripcion;
                    text = 'documentation-acountText0';
                    accountType = 2;
                    priority = 0;
                }
                precontractualInfo = precontractualInfo.push(
                    Immutable.Map({
                        id: value.id,
                        url: value.url,
                        description: title,
                        text,
                        priority,
                    }).toObject()
                );
            });

            return state.merge({
                precontractualInfo,
                accountType,
            });

        case actionTypes.CLEAR_CONTRACTUAL_INFO:
            return state.merge({
                precontractualInfo: [],
                accountType: 0,
            });

        case actionTypes.GET_PDF_MERGED:
            return state.merge({
                pdfDownloadLink: action.data,
                pdfDownloadLinkName: formatText('documentation-contractLegalPdfTtitle'),
            });

        case actionTypes.CLEAR_PDF_MERGED:
            return state.merge({
                pdfDownloadLink: null,
            });

        case actionTypes.IS_LOADED_IN_DOCUMENTATION:
            return state.merge({
                isLoadedInDocumentationInfo: true,
            });

        case actionTypes.FROM_INITIAL_STEP:
            return state.merge({
                fromInitialStep: action.value,
            });

        default:
            return state;
    }
};

module.exports = initialStepReducer;
